export class PatchOp {
  constructor(
    readonly path: string,
    readonly op: 'replace' | 'add' | 'remove' | 'test',
    readonly value?: any,
  ) {}
}
